/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { postMergeUserAccountsThunk, getValidateEmailOrUsernameThunk } from './users.merge.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  userId: undefined,
  dialog: { open: false },
  error: undefined,
  mergeSucceeded: undefined,
};

/* Slice */
export const mergeUserAccountSlice = createSlice({
  name: 'mergeUserAccount',
  initialState,
  reducers: {
    toggleDialog(state, action) {
      state.dialog.open = action.payload;
      state.mergeSucceeded = false;
      state.error = undefined;
    },
    setSearchValue(state, action) {
      state.userId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(postMergeUserAccountsThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
        state.dialog.open = false;
      })
      .addCase(postMergeUserAccountsThunk.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.userId = undefined;
        state.dialog.open = true;
        state.error = undefined;
        state.mergeSucceeded = true;
      })
      .addCase(postMergeUserAccountsThunk.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.dialog.open = true;
        state.error = action.payload.data;
      })
      .addCase(getValidateEmailOrUsernameThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(getValidateEmailOrUsernameThunk.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.userId = action.payload;
        state.dialog.open = true;
        state.error = undefined;
      })
      .addCase(getValidateEmailOrUsernameThunk.rejected, (state) => {
        state.status = ThunkStatus.FAILED;
        state.dialog.open = true;
      });
  },
});

/* Selectors */
const selectMergeUserAccountSlice = state => state[mergeUserAccountSlice.name];

export const selectDialog = createSelector(selectMergeUserAccountSlice, s => s.dialog);
export const selectStatus = createSelector(selectMergeUserAccountSlice, s => s.status);
export const selectUserId = createSelector(selectMergeUserAccountSlice, s => s.userId);
export const selectmergeSucceeded = createSelector(selectMergeUserAccountSlice, s => s.mergeSucceeded);
export const selectError = createSelector(selectMergeUserAccountSlice, s => s.error);

/* Actions */
export const { toggleDialog, setSearchValue } = mergeUserAccountSlice.actions;
